import React, { memo, useState, useCallback, useMemo } from "react";
import WidgetCard from "./WidgetCard";
import { AiOutlineSafetyCertificate } from "react-icons/ai";
import { ProgressBar, Col, Row } from "react-bootstrap";
import { getExpiringCertificatesData } from "services/stillageDashboard";
import { useDispatch } from 'react-redux';
import { openModal } from "slices/stillageWidgetModalSlice";
import PropTypes from 'prop-types';

const DotKey = memo(({ bg, text, onEnter, onLeave, onClick }) =>
(
    <Col
        className="text-center"
        onMouseEnter={onEnter}
        onMouseLeave={onLeave}
        onClick={onClick}
        tabIndex={0}>
        <div style={{ width: 12, height: 12, verticalAlign: "middle", display: "inline-block" }} className={`rounded-circle ${bg}`}></div>
        <span className="ms-1 text-end">{text}</span>
    </Col>
));

const Certificates = ({ data, loading }) => {
    const { expCerts, notCert, certified } = getExpiringCertificatesData(data);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const dispatch = useDispatch();

    const handleEnter = useCallback((i) => () => setHoveredIndex(i), []);
    const handleLeave = useCallback(() => setHoveredIndex(null), []);

    const total = expCerts?.lenght + notCert?.length + certified?.lenght || 1;
    const pct = (n) => (n * 100 / total) || 0;

    const segmentBaseStyle = useMemo(() => ({
        transformOrigin: 'center',
        transition: 'transform 160ms ease, boxShadow 160ms ease',
        position: 'relative',
        // zIndex: 1,
        overflow: 'visible'
    }), []);

    const hoveredStyle = useMemo(() => ({
        transform: 'scaleY(1.15)',
        boxShadow: '0 0px 15px rgba(0,0,0,0.16)',
        // zIndex: 9999
    }), []);

    const certs = [
        { label: 'No Cert.', value: notCert, variant: 'danger' },
        { label: 'Exp. ~3m', value: expCerts, variant: 'warning' },
        { label: 'Certified', value: certified, variant: 'success' }
    ];

    return (
        <WidgetCard title="Certificates" icon={<AiOutlineSafetyCertificate />} loading={loading} >
            <Row className="m-3">
                <Col>
                    <ProgressBar className="shadow-sm border" style={{ overflow: 'visible' }}>
                        {
                            certs.map((cert, idx) => (
                                <ProgressBar
                                    variant={cert.variant}
                                    now={pct(cert.value?.length)}
                                    label={cert.value?.length}
                                    key={idx}
                                    style={{
                                        ...segmentBaseStyle,
                                        ...(hoveredIndex === idx ? hoveredStyle : { transform: 'scaleY(1)' })
                                    }}
                                    onMouseEnter={handleEnter(idx)}
                                    onMouseLeave={handleLeave}
                                    onClick={() => dispatch(openModal({ title: cert.label, data: cert.value || [], loading }))}
                                />
                            ))
                        }
                    </ProgressBar>
                </Col>
            </Row>
            <Row className="mt-1 fs--1 fw-semibold text-500 d-flex justify-content-evenly">
                {
                    certs.map((cert, idx) => (
                        <DotKey
                            key={idx}
                            onEnter={handleEnter(idx)}
                            onLeave={handleLeave}
                            onClick={() => dispatch(openModal({ title: cert.label, data: cert.value || [], loading }))}
                            text={cert.label}
                            bg={`bg-${cert.variant}`} />
                    ))
                }
            </Row>
        </WidgetCard>
    )
}

Certificates.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool
};

DotKey.propTypes = {
    bg: PropTypes.string,
    text: PropTypes.string,
    onEnter: PropTypes.func,
    onLeave: PropTypes.func,
    onClick: PropTypes.func
};

export default memo(Certificates);